module.exports = __webpack_public_path__ + "media/images/flags/1x1/eri-b390597b0748cbb7eec1146e57b105fe.svg";